import { NavService } from '../../features/navigation/nav.service'
import { FeathersService } from '../feathers.service'
import { inject, Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { PrimeNgToastService } from '../prime-ng-toast/prime-ng-toast.service'

export type LogoutToast = {
  reason: string
  isPositive: boolean
  durationMs?: number
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private nav = inject(NavService)
  private toaster = inject(PrimeNgToastService)

  public logout$: Subject<void> = new Subject<void>()

  public async requestLogout(feathers: FeathersService, toast: LogoutToast) {
    try {
      await feathers.logout()
      feathers.dataStoreHolder.unregisterAllDataStores()
      this.logout$.next()
      this.logout$.complete()
    } finally {
      await this.nav.goToLogin()
      await this.showToast(toast)
    }
  }

  private async showToast(toast: LogoutToast) {
    this.toaster.displayCustomToast(toast.isPositive ? 'success' : 'warn', toast.reason, {
      durationMs: toast.durationMs ?? 3000,
    })
  }
}
